export const SELECCION = {
  NINGUNO: 0,
  MARCADO: 1,
  AUTORIZADO: 3,
} as const;

export const ESTATUS_PRODUCTO = {
  RECHAZADO: 2,
} as const;

export const ESTATUS_COTIZACION_COMPUTO = {
  ENVIADA_AUTORIZAR: 3,
} as const;

export const DISPONIBLE = 1;

export const COMPUTO_SI = "si";

/** Colores por defecto de los botones del modal de cotización */
export const COLORES_ACCION_COTIZACION = {
  color: "#dec162",
  hoverColor: "#826f30",
  textColor: "#000",
} as const;

export const MENSAJES = {
  recotizarOk: "Productos enviados a recotizar correctamente.",
  recotizarError: "No se pudo enviar a recotizar.",
  marcarError: "No se pudieron marcar los productos.",
  todosAutorizados: "Todos los productos autorizados",
} as const;
